import { usePopup } from 'hooks/usePopup';

import RoutingNumberHelpPopup from './RoutingNumberHelpPopup';

export const useRoutingNumberHelpPopup = () => {
  const { showPopup, hidePopup } = usePopup();

  const showRoutingNumberHelpPopup = () => {
    showPopup(<RoutingNumberHelpPopup onClose={() => hidePopup()} />, { keepPopups: true });
  };

  return { showRoutingNumberHelpPopup };
};
